import { render, staticRenderFns } from "./UserImports.vue?vue&type=template&id=53511498&"
import script from "./UserImports.vue?vue&type=script&lang=js&"
export * from "./UserImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports